import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { colors } from '../styles/colors';
import {
  Africa,
  Australia,
  Caribbean,
  Dubai,
  EastAsia,
  Europe,
  IndiaOcean,
  NorthAmerica,
  Polar,
  South,
} from './SmallDrawer';
import BackButton from './BackButton';
import LeftDrawer from './LeftDrawer';
import { useDispatch } from 'react-redux';
import { setDestinations } from '../features/destination/destinationSlice';
import { countries } from '../constants/menuItems';

const data = [
  {
    name: 'Africa',
    component: <Africa />,
    isName: true,
    index: 1,
    menus: countries.africa,
  },
  {
    name: 'Australia/NZ/Pacific',
    component: <Australia />,
    isName: true,
    index: 2,
    menus: countries.australia,
  },
  {
    name: 'Caribbean',
    component: <Caribbean />,
    isName: true,
    index: 3,
    menus: countries.caribbean,
  },
  {
    name: 'Dubai & Middle East',
    component: <Dubai />,
    isName: true,
    index: 4,
    menus: countries.middleEast,
  },
  {
    name: 'Europe',
    component: <Europe />,
    isName: true,
    index: 5,
    menus: countries.europe,
  },
  {
    name: 'Far East & Asia',
    component: <EastAsia />,
    isName: true,
    index: 6,
    menus: countries.farEast,
  },
  {
    name: 'Indian Ocean',
    component: <IndiaOcean />,
    isName: true,
    index: 7,
    menus: countries.indiaOcean,
  },
  {
    name: 'North America',
    component: <NorthAmerica />,
    isName: true,
    index: 8,
    menus: countries.northAmerica,
  },
  {
    name: 'Polar',
    component: <Polar />,
    isName: true,
    index: 9,
    menus: countries.polar,
  },
  {
    name: 'South & Central America',
    component: <South />,
    isName: true,
    index: 10,
    menus: countries.southCentralAmerica,
  },
];

const MobileDestinations = () => {
  const [toggle, setToggle] = useState(false);
  const [currentIndex, setCurrentIndex] = useState<number>(null || 0);
  const [showResults, setShowResults] = React.useState(false);
  const dispatch = useDispatch();

  const handleContinentClick = (item: any) => {
    setCurrentIndex(item.index);
    dispatch(setDestinations(item.menus));
    item.index !== currentIndex ? setToggle(true) : setToggle(!toggle);
  };
  return (
    <>
      <Box p='1.25rem 1.875rem'>
        {showResults ? (
          <LeftDrawer />
        ) : (
          <Box flex='0 0 25%'>
            <Box>
              <Box pb='20px' pt='20px' onClick={() => setShowResults(true)}>
                <BackButton />
              </Box>
              <Box>
                <Typography variant='h1' fontFamily='Raleway,sans-serif' mb='0.625rem'>
                  Choose a destination
                </Typography>
              </Box>
              <Box pl='10px'>
                {data?.map((item: any) => {
                  return (
                    item.isName && (
                      <Box
                        key={item.index}
                        flexGrow={1}
                        mb='5px'
                        justifyContent='center'
                        alignSelf='flex-end'
                        sx={{
                          '& button': {
                            minWidth: 'auto',
                          },
                        }}
                      >
                        <Button
                          sx={{
                            display: 'block',
                            p: '.625rem 0',
                            mr: { xs: '16px', lg: '20px' },

                            '& h6': {
                              color:
                                item.index === currentIndex && toggle && [1, 2].includes(item.index)
                                  ? colors.basics.primary
                                  : '#303030',
                            },
                          }}
                          disableRipple={true}
                          variant='text'
                          onClick={() => {
                            handleContinentClick(item);
                          }}
                        >
                          <Typography
                            variant='subtitle1'
                            fontWeight={500}
                            lineHeight='130%'
                            color={colors.grey[10]}
                            fontSize='16px'
                            sx={{
                              '&:hover': {
                                color: colors.basics.primary,
                              },
                            }}
                          >
                            {item.name}
                          </Typography>
                        </Button>

                        <div hidden={!toggle}>
                          <Box
                            position='absolute'
                            zIndex={1}
                            width='100%'
                            left={0}
                            height='100%'
                            top={0}
                            bgcolor={colors.basics.lightmain}
                            display={item.index === currentIndex ? 'block' : 'none'}
                            sx={{
                              '&>.MuiBox-root': {
                                p: '1.25rem 1.875rem',
                                '&>.MuiBox-root': {
                                  bgcolor: 'transparent',
                                },
                              },
                              listStyle: 'none',
                            }}
                          >
                            {item.index === currentIndex && item.component}
                          </Box>
                        </div>
                      </Box>
                    )
                  );
                })}
              </Box>
            </Box>
          </Box>
        )}
      </Box>
    </>
  );
};

export default MobileDestinations;
